// extracted by mini-css-extract-plugin
export default {"main":"Sidebar_main__bzCMF","link":"Sidebar_link__uc+K7","active":"Sidebar_active__aXoCe","logout":"Sidebar_logout__NfdNN"};